import { enableProdMode, provideZonelessChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { WrapperModule } from './wrapper.module';

// @ts-ignore: Needs to be ignored so the typescript compiler replaces CONFIGURATION
export const configuration: string = CONFIGURATION;

if (configuration !== 'development') {
    enableProdMode();
}

platformBrowser()
    .bootstrapModule(WrapperModule, { applicationProviders: [provideZonelessChangeDetection()] })
    .catch((err) => console.error(err)); // NOSONAR
